module.exports = __webpack_public_path__ + "static/desktop/img/pic_empty.1edb46ad.png";